export default __webpack_public_path__ + "assets/outlined-right-center-circle.svg";